module.exports = __webpack_public_path__ + "static/media/buffalo-chicken-noodles.63faa3d8.png";